import JdbcReaderNode from './types/jdbc-reader';
import JdbcWriterNode from './types/jdbc-writer';

export const jdbcNodes = {
  jdbcReader: JdbcReaderNode,
  jdbcWriter: JdbcWriterNode,
};
